/* =========================================================
   Plantive Hero - JS (GSAP Animated Lines)
========================================================= */

document.addEventListener('DOMContentLoaded', () => {

  let splitInstances = [];

  const initGSAP = () => {
    // เช็คว่าโหลดสคริปต์มาครบแล้วหรือยัง
    if (typeof gsap !== 'undefined' && typeof SplitType !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
      
      gsap.registerPlugin(ScrollTrigger);

      const heroes = document.querySelectorAll('.pv-hero-container');
      
      heroes.forEach(hero => {
        // เปิดความสว่างให้กล่องแม่ (แก้ FOUC กระพริบ)
        gsap.set(hero.querySelectorAll('.js-split-text, .js-fade-btn'), { opacity: 1, visibility: 'visible' });

        const splitElements = hero.querySelectorAll('.js-split-text');
        
        if(splitElements.length > 0) {
            // หั่นบรรทัดตัวหนังสือ
            const splitTexts = new SplitType(splitElements, { types: 'lines', lineClass: 'plv-line' });
            splitInstances.push(splitTexts);

            // สร้าง Timeline (ใช้ ScrollTrigger เผื่อลูกค้านำไปวางไว้กลางหน้าเว็บ)
            const tl = gsap.timeline({
                scrollTrigger: {
                    trigger: hero,
                    start: "top 80%" // แง้มเข้ามา 20% ของจอก็เริ่มเล่นเลย
                }
            });

            // 1. แอนิเมชันตัวหนังสือเด้งขึ้นมาทีละบรรทัด
            tl.from(splitTexts.lines, {
                y: 40,
                opacity: 0,
                duration: 1,
                stagger: 0.1, // ค่อยๆ ทยอยขึ้นมา
                ease: "power3.out",
                delay: 0.2
            });

            // 2. แอนิเมชันปุ่มแคปซูลเฟดลอยตามขึ้นมา
            const btn = hero.querySelectorAll('.js-fade-btn');
            if (btn.length > 0) {
              tl.from(btn, {
                  y: 20,
                  opacity: 0,
                  duration: 0.8,
                  ease: "power3.out"
              }, "-=0.6"); // ให้เด้งออกมาก่อนตัวหนังสือจะจบ 0.6 วินาที
            }
        }
      });
      
    } else {
      setTimeout(initGSAP, 100);
    }
  };

  initGSAP();

  // 🔄 ระบบ Responsive: หั่นบรรทัดใหม่เมื่อหมุนจอมือถือ
  let windowWidth = window.innerWidth;
  let resizeTimer;
  
  window.addEventListener('resize', () => {
    if (window.innerWidth !== windowWidth) {
      windowWidth = window.innerWidth;
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        splitInstances.forEach(instance => instance.revert());
        splitInstances = [];
        initGSAP();
      }, 250);
    }
  });

});